// Safe fallback for an unknown/invalid widget spec (TASK-493). Keeps the canvas
// resilient — an unregistered component name never crashes the grid.

interface FallbackCardProps {
  component?: string;
  message?: string;
}

export function FallbackCard({ component, message }: FallbackCardProps) {
  return (
    <div className="rounded-[14px] border border-border bg-card p-4">
      <p className="text-[13px] font-medium text-muted-foreground">
        {component ? `Unknown widget: ${component}` : message ?? 'Widget unavailable'}
      </p>
      {component && message && (
        <p className="mt-1 text-[12px] text-muted-foreground/70">{message}</p>
      )}
    </div>
  );
}
